import { classNameType } from "@/types/generalTypes";
import React from "react";

function User({ className }: classNameType) {
  return (
    <svg
      className={className}
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.424 6.5476C16.424 8.93377 14.4054 10.9079 11.8653 10.9079C9.32516 10.9079 7.30654 8.93377 7.30654 6.5476C7.30654 4.16142 9.32516 2.18728 11.8653 2.18728C14.4054 2.18728 16.424 4.16142 16.424 6.5476Z"
        stroke="#4A4A4A"
        strokeWidth="1.2"
      />
      <mask id="path-2-inside-1_484_2309" fill="white">
        <path d="M11.8653 13.0952C7.59362 13.0998 4.13195 16.4283 4.1272 20.5357C4.1272 20.9923 4.51213 21.3624 4.98697 21.3624H18.7436C19.2184 21.3624 19.6033 20.9923 19.6033 20.5357C19.5986 16.4283 16.137 13.0997 11.8653 13.0952Z" />
      </mask>
      <path
        d="M11.8653 13.0952L11.8666 11.8952L11.864 11.8952L11.8653 13.0952ZM4.1272 20.5357L2.9272 20.5343V20.5357H4.1272ZM19.6033 20.5357H20.8033L20.8033 20.5343L19.6033 20.5357ZM11.864 11.8952C6.97528 11.9004 2.93277 15.7215 2.9272 20.5343L5.3272 20.5371C5.33114 17.1352 8.21196 14.2991 11.8666 14.2952L11.864 11.8952ZM2.9272 20.5357C2.9272 21.6989 3.89418 22.5624 4.98697 22.5624V20.1624C5.13008 20.1624 5.3272 20.2856 5.3272 20.5357H2.9272ZM4.98697 22.5624H18.7436V20.1624H4.98697V22.5624ZM18.7436 22.5624C19.8364 22.5624 20.8033 21.6989 20.8033 20.5357H18.4033C18.4033 20.2856 18.6005 20.1624 18.7436 20.1624V22.5624ZM20.8033 20.5343C20.7978 15.7215 16.7553 11.9004 11.8666 11.8952L11.864 14.2952C15.5186 14.2991 18.3994 17.1352 18.4033 20.5371L20.8033 20.5343Z"
        fill="#4A4A4A"
        mask="url(#path-2-inside-1_484_2309)"
      />
    </svg>
  );
}

export default User;
